var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#287C87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59425 3.74942L6.1455 3.07183C6.66854 2.42892 7.40367 2.0023 8.18916 1.88584C8.97464 1.76938 9.74615 1.9726 10.334 2.45081C10.9218 2.92902 11.2777 3.64304 11.3235 4.4358C11.3693 5.22855 11.1012 6.0351 10.5782 6.67802L10.0269 7.3556L9.14038 6.63436L9.69163 5.95678C10.0055 5.57103 10.1663 5.0871 10.1388 4.61145C10.1114 4.1358 9.89779 3.70738 9.54511 3.42046C9.19242 3.13353 8.72952 3.0116 8.25822 3.08147C7.78693 3.15135 7.34586 3.40732 7.03203 3.79307L6.48079 4.47065L5.59425 3.74942Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0774 6.39844C11.2985 6.44592 11.5036 6.56433 11.6653 6.74109C11.8796 6.97552 12 7.29346 12 7.625V10.75C12 11.0815 11.8796 11.3995 11.6653 11.6339C11.4509 11.8683 11.1602 12 10.8571 12H5.14286C4.83975 12 4.54906 11.8683 4.33473 11.6339C4.12041 11.3995 4 11.0815 4 10.75V7.625C4 7.29346 4.12041 6.97552 4.33473 6.74109C4.49638 6.56433 4.70148 6.44592 4.92257 6.39844H11.0774Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteUnlocked);
export default __webpack_public_path__ + "static/media/quote-unlocked.b1390bab678f920583edafcdc1f9977d.svg";
export { ForwardRef as ReactComponent };